import React, { useEffect, useState } from "react";
import { FormikProvider, useFormik, Form, Field, ErrorMessage } from "formik";
import * as bie from "react-bootstrap";
import * as Yup from "yup";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly } from "../CommonUtils/CommonValidations";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import { failureAlert } from "../CommonUtils/SweetAlerts";
import { ERROR_MSG, MOBILE_VALIDATION } from "../CommonUtils/contextVariables";

const InstitutionDetails = () => {
  /* ===================== VALIDATION ===================== */
  const validationSchema = Yup.object({
    principalName: Yup.string().required(ERROR_MSG).nullable(),
    principalMobile: Yup.string()
      .required(ERROR_MSG).nullable()
      .matches(MOBILE_VALIDATION, "Invalid mobile number"),

    coordinatorName: Yup.string().required(ERROR_MSG).nullable(),
    typeOfInst: Yup.string().required(ERROR_MSG).nullable(),
    coordinatorMobile: Yup.string()
      .required(ERROR_MSG).nullable()
      .matches(MOBILE_VALIDATION, "Invalid mobile number"),

    collMail: Yup.string().required(ERROR_MSG).nullable(),

    collWebsite: Yup.string().required(ERROR_MSG).nullable(),
  });
  /* ===================== FORMIK ===================== */
  const formik = useFormik({
    initialValues: {
      instName: "",
      aisheCode: "",
      districtName: "",
      typeOfInst: "",
      principalName: "",
      principalMobile: "",
      coordinatorName: "",
      coordinatorMobile: "",
      collMail: "",
      collWebsite: "",
    },
    validationSchema,
    onSubmit: (val) => {
      const payload = {
        districtName: clgdtls[0]?.inst_dist_code || "",
        typeOfInst: parseInt(val.typeOfInst || 10) || 0,
        principalName: val.principalName,
        coordinatorName: val.coordinatorName,
        principalMobile: val.principalMobile,
        coordinatorMobile: val.coordinatorMobile,
        collWebsite: val.collWebsite,
        collMail: val.collMail,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      };
      Swal.fire({
        text: "Are you sure you want to Update?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Update it!",
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = config.url.API_URL + "updateRusaInstDetails";
          CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              Swal.fire(res?.data?.sdesc, "", "success").then((r) => {
                GetsubmittedDetails();
                // if (r.isConfirmed) window.location.reload();
              });
            } else {
              failureAlert("Failed to submit");
            }
          })
        }
      });
    },
  });
  /* ===================== API ===================== */
  const [clgdtls, setClgdtls] = useState([]);
  const GetclgDtls = () => {
    const url = `${config.url.API_URL}getRusaCollegeDetails`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.scode === "01" && res?.data?.data?.length > 0) {
          const data = res.data?.data[0];
          setClgdtls(res?.data?.data);
          formik.setValues((prev) => ({
            ...prev,
            instName: data?.inst_name || "",
            districtName: data?.dist_name || "",
            aisheCode: data?.aishe_code === "tsg" ? "S-0001" : data?.aishe_code || "",
          }));
        }
      })
      .catch((err) => {
        console.error("API ERROR:", err);
      });
  };

  function GetsubmittedDetails() {
    const url = `${config.url.API_URL}getRusaInstDetailsList`;
    CommonAxiosGet(url).then(res => {
      if (res?.data?.scode === "01") {
        formik.setFieldValue("instName", res?.data?.data[0]?.inst_name || "");
        formik.setFieldValue("districtName", res?.data?.data[0]?.dist_name || "");
        formik.setFieldValue("typeOfInst", res?.data?.data[0]?.type_of_inst?.toString() || "");
        formik.setFieldValue("principalName", res?.data?.data[0]?.principal_name || "");
        formik.setFieldValue("coordinatorName", res?.data?.data[0]?.coordinator_name || "");
        formik.setFieldValue("principalMobile", res?.data?.data[0]?.principal_mobile || "");
        formik.setFieldValue("coordinatorMobile", res?.data?.data[0]?.coordinator_mobile || "");
        formik.setFieldValue("collMail", res?.data?.data[0]?.coll_mail || "");
        formik.setFieldValue("collWebsite", res?.data?.data[0]?.coll_website || "");


      }
      else {
        setClgdtls([]);
      }
    });
  }

  const [Instnames, setinstanmes] = useState([]);
  function GetInstTypeList() {
    let url = config.url.API_URL + `getNatureCode`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setinstanmes(res?.data?.data)

      } else {
        setinstanmes([])
      }
    })
  }

  useEffect(() => {
    GetInstTypeList();
    GetclgDtls();
    GetsubmittedDetails();
  }, []);

  /* ===================== UI ===================== */
  return (
    <div className="pt-3">
      <div className="overal-stathead">
        <span>Institution Details</span>
      </div>
      <FormikProvider value={formik}>
        <Form>
          <bie.Row className="g-3">
            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>Institution Name</label>
              <Field
                name="instName"
                className="form-control"
                disabled
              />

            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>AISHE Code</label>
              <Field
                name="aisheCode"
                className="form-control"
                disabled
              />

            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>District</label>
              <Field
                name="districtName"
                className="form-control"
                disabled
              />

            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>Type of Institution</label>
              <Field as='select' name="typeOfInst" className="form-control">
                <option value=''>--select--</option>
                {Instnames?.map((p) => (
                  <option key={p.coll_nature_code} value={p.coll_nature_code}>
                    {p.coll_nature_name}
                  </option>
                ))}

              </Field>
              <ErrorMessage
                name="typeOfInst"
                component="div"
                className="form-error"
                role="alert"
              />


            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>Registrar / Principal Name</label>
              <Field
                name="principalName"
                className="form-control"
                onKeyPress={allowAlphabetAndSpacesOnly}
                maxLength={40}
              />
              <ErrorMessage
                name="principalName"
                component="div"
                className="text-danger"
              />
            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>Registrar/Principal Number </label>
              <Field
                name="principalMobile"
                className="form-control"
                maxLength={10}
                onKeyPress={allowNumbersOnly}
              />
              <ErrorMessage
                name="principalMobile"
                component="div"
                className="text-danger"
              />
            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>RUSA / PM-USHA Coordinator Name</label>
              <Field
                name="coordinatorName"
                className="form-control"
                onKeyPress={allowAlphabetAndSpacesOnly}
                maxLength={40}

              />
              <ErrorMessage
                name="coordinatorName"
                component="div"
                className="text-danger"
              />
            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>RUSA / PM-USHA Coordinator Mobile Number </label>
              <Field name="coordinatorMobile" className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} />
              <ErrorMessage name="coordinatorMobile" component="div" className="text-danger" />
            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>College Mail ID</label>
              <Field name="collMail" type="email" className="form-control" maxLength="40" />
              <ErrorMessage name="collMail" component="div" className="text-danger" />
            </bie.Col>

            <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
              <label>Website ID with RUSA/PM-USHA page </label>
              <Field name="collWebsite" className="form-control" maxLength="30" />
              <ErrorMessage name="collWebsite" component="div" className="text-danger" />
            </bie.Col>
          </bie.Row>

          <div className="text-end mt-3">
            <button type="submit" className="btn btn-success">
              Submit
            </button>
          </div>
        </Form>
      </FormikProvider>
    </div>
  );
};
export default InstitutionDetails;
